 document.addEventListener("DOMContentLoaded", (event) => {
  var trigger = document.querySelector('.select-trigger');
  var selectList = document.querySelector('.select-list');
  if (trigger) {
    trigger.addEventListener("click", () => {
      if (selectList.classList.contains('open')) {
        selectList.classList.remove('open');
        console.log('hide');
      } else {
        selectList.classList.add('open');
        console.log('show');
      }
    });
  }
});